module.exports = __webpack_public_path__ + "img/f1.5b935c94.png";